import { render, staticRenderFns } from "./StoreDetailDialog.vue?vue&type=template&id=47fe79b1&scoped=true"
import script from "./StoreDetailDialog.vue?vue&type=script&lang=js"
export * from "./StoreDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./StoreDetailDialog.vue?vue&type=style&index=0&id=47fe79b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fe79b1",
  null
  
)

export default component.exports